import { Box, Typography } from '@mui/material';
import styled, { css } from 'styled-components';

import { TFileUploadedContainerProps } from '@/shared/components/ui/form/components/file-dropzone/components/dropzone-input/dropzone-input.types';

export const DropzoneContainer = styled(Box)`
  && {
    height: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${({ theme }) => theme.palette.background.default};
  }
`;

export const FileUploadedContainer = styled(Box)<TFileUploadedContainerProps>`
  && {
    background-color: ${({ theme }) => theme.palette.background.default};
    display: flex;
    flex-direction: column;
    padding: 0.5rem 1rem;
    border: 1px solid ${({ theme }) => theme.palette.primary.light};
    border-radius: ${({ theme }) => theme.shape.inputRadius.medium};
    align-items: center;
    justify-content: space-between;

    ${({ $multiple }) =>
      $multiple &&
      css`
        margin-top: 0.5rem;
        padding: 0;
        border: none;
        background-color: transparent;
      `}
  }
`;

export const FileInfo = styled(Box)`
  && {
    display: flex;
    flex-direction: row;
    gap: 0.375rem;
    align-items: center;
    max-width: 100%;
    min-width: 0;

    svg {
      min-width: 1.25rem;
      min-height: 1.25rem;
    }
  }
`;

export const FileInfoPrimary = styled(Typography)`
  && {
    ${({ theme }) => theme.typography.p8};
    color: ${({ theme }) => theme.palette.text.primary};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const FileInfoSecondary = styled(Typography)`
  && {
    color: ${({ theme }) => theme.palette.text.secondary};
    ${({ theme }) => theme.typography.p8};

    ${FileInfo}[disabled] & {
      color: ${({ theme }) => theme.palette.text.disabled};
    }
    white-space: nowrap;
  }
`;
